import { Button } from '@/components';
import { FunctionComponent, memo, useCallback, useRef, useState } from 'react';

import CurrentSituationExcel from '.';
import { IProps } from './type';

const CurrentSituationExcelButton = () => {
	const [open, setOpen] = useState(false);

	const currentSituationExcel = useRef<FunctionComponent<IProps>>();

	const onOpenModal = useCallback(() => {
		if (!currentSituationExcel.current) {
			currentSituationExcel.current = CurrentSituationExcel;
		}

		setOpen(true);
	}, [currentSituationExcel.current]);

	const onCancel = useCallback(() => {
		setOpen(false);
		currentSituationExcel.current = undefined;
	}, [currentSituationExcel.current]);

	return (
		<>
			<Button onClick={onOpenModal}>운영 현황 엑셀 다운로드</Button>

			{currentSituationExcel.current && (
				<currentSituationExcel.current {...{ open, onCancel }} />
			)}
		</>
	);
};

export default memo(CurrentSituationExcelButton);
